export const uuid = () => self.crypto.randomUUID();
